import { render } from "./ZipButton.vue?vue&type=template&id=1d42722e&lang=true"
import script from "./ZipButton.vue?vue&type=script&lang=js"
export * from "./ZipButton.vue?vue&type=script&lang=js"
script.render = render

export default script